import isSuperAdmin from '../guards/isSuperAdmin';

export default [
  {
    name: "super-admin-dashboard",
    path: "/super-admin/dashboard",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/SuperAdminDashboard"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "super-admin-academic-years",
    path: "/super-admin/academic-years",
    component: () =>
      import(
        /* webpackChunkName: "chunks/academic-years" */ "@views/academic_years/AcademicYearsList"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "super-admin-schools",
    path: "/super-admin/schools",
    component: () =>
      import(
        /* webpackChunkName: "chunks/schools" */ "@views/schools/SchoolsList"
      ),
    meta: {
      requiresAuth: true,
      permission: "VIEW_SCHOOLS",
    },
  },
  {
    name: "super-admin-roles",
    path: "/super-admin/roles",
    component: () =>
      import(/* webpackChunkName: "chunks/roles" */ "@views/roles/RolesList"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "create-roles",
    path: "/super-admin/roles/create",
    component: () =>
      import(/* webpackChunkName: "chunks/roles" */ "@views/roles/NewRoleForms"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "super-admin-edit-roles",
    path: "/super-admin/roles/edit/:id",
    component: () =>
      import(/* webpackChunkName: "chunks/roles" */ "@views/roles/NewRoleForms"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "super-admin-users",
    path: "/super-admin/users",
    component: () =>
      import(/* webpackChunkName: "chunks/users" */ "@views/users/UsersList"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "Data-Masking-Settings",
    path: "/super-admin/data-masking-settings",
    component: () =>
      import(
        /* webpackChunkName: "chunks/schools" */ "@views/mask_field/MaskList"
      ),
    meta: {
      requiresAuth: true,
      permission: "VIEW_MASKINGFIELDS",
    },
  },
  {
    name: "create-Data-Masking-Settings",
    path: "/super-admin/data-masking-settings/create",
    component: () =>
      import(
        /* webpackChunkName: "chunks/roles" */ "@views/mask_field/MaskForms"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "edit-Data-Masking-Settings",
    path: "/super-admin/data-masking-settings/edit/:id",
    component: () =>
      import(
        /* webpackChunkName: "chunks/roles" */ "@views/mask_field/MaskForms"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "super-admin-districts",
    path: "/super-admin/districts",
    component: () =>
      import(
        /* webpackChunkName: "chunks/district" */ "@views/districts/DistrictList"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "super-admin-administrative-regions",
    path: "/super-admin/administrative-regions",
    component: () =>
      import(
        /* webpackChunkName: "chunks/administrative-regions" */ "@views/administrative_regions/RegionList"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "super-admin-relationship-statuses",
    path: "/super-admin/relationship-statuses",
    component: () =>
      import(
        /* webpackChunkName: "chunks/relationship-statuses" */ "@views/relationship_statuses/RelationshipStatusesList"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "super-admin-religions",
    path: "/super-admin/religions",
    component: () =>
      import(
        /* webpackChunkName: "chunks/religions" */ "@views/religions/ReligionsList"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "admission-civil-status",
    path: "/super-admin/admission/civil-status",
    component: () =>
      import(
        /* webpackChunkName: "chunks/admissions/civil-status" */ "@views/admissions/civil_status/CivilStatusList"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "super-admin-nationalities",
    path: "/super-admin/nationalities",
    component: () =>
      import(
        /* webpackChunkName: "chunks/nationalities" */ "@views/nationalities/NationalitiesList"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "super-admin-previous_schools",
    path: "/super-admin/PreviousSchools",
    component: () =>
      import(
        /* webpackChunkName: "chunks/previousSchools" */ "@views/previous_schools/SchoolList"
      ),
  },
  {
    name: "super-admin-prev-school-types",
    path: "/super-admin/prev-school-types",
    component: () =>
      import(
        /* webpackChunkName: "chunks/dashboard" */ "@views/prev_school_types/PrevSchoolTypesList"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "super-admin-disability-types",
    path: "/super-admin/disability-types",
    component: () =>
      import(
        /* webpackChunkName: "chunks/district" */ "@views/disability_types/DisabilityTypeList"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "super-admin-chronic-diseases",
    path: "/super-admin/chronic-diseases",
    component: () =>
      import(
        /* webpackChunkName: "chunks/chronic_diseases" */ "@views/chronic_diseases/ChronicDiseasesList"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "show-roles",
    path: "/super-admin/roles/show/:id",
    component: () =>
      import(
        /* webpackChunkName: "chunks/roles" */ "@views/roles/ShowRoleForm"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "system-tests",
    path: "/super-admin/system-tests",
    component: () =>
      import(
        /* webpackChunkName: "chunks/system-tests" */ "@views/system_tests/SystemTestList"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "super-admin-language-settings",
    path: "/super-admin/language-settings",
    component: () =>
      import(
        /* webpackChunkName: "chunks/languages" */ "@views/languages/LanguageSettings"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "system-general-settings",
    path: "/super-admin/general-settings",
    component: () =>
      import(
        /* webpackChunkName: "chunks/settings" */ "@views/settings/GeneralSettings"
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "super-admin-areas",
    path: "/super-admin/areas",
    component: () =>
      import(
        /* webpackChunkName: "chunks/areas" */ "@views/areas/AreaList"
      ),
    meta: {
      requiresAuth: true,
      permission: "VIEW_AREAS",
    },
  },
  {
    name: "super-admin-blocks",
    path: "/super-admin/blocks",
    component: () =>
      import(
        /* webpackChunkName: "chunks/blocks" */ "@views/blocks/BlockList"
      ),
    meta: {
      requiresAuth: true,
      permission: "VIEW_BLOCKS",
    },
  },
];
